import { Component, OnInit, OnDestroy, Input, HostBinding } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

import { EuiTableSortService } from '../services/eui-table-sort.service';

@Component({
    // tslint:disable-next-line
    selector: 'th[sortable]',
    templateUrl: './eui-table-sortable-col.component.html',
    host: { 'class': 'eui-table__sortable-col' },
})

export class EuiTableSortableColComponent implements OnInit, OnDestroy {

    @Input() sortOn: string;
    @Input() sortOrder: ('asc' | 'desc') = 'desc';

    @Input()
    get defaultOrder() { return this._defaultOrder; }
    set defaultOrder(value) { this._defaultOrder = coerceBooleanProperty(value); }
    _defaultOrder = false;

    @Input()
    get sortDisabled() { return this._sortDisabled; }
    set sortDisabled(value) { this._sortDisabled = coerceBooleanProperty(value); }
    _sortDisabled = false;

    public order: ('asc' | 'desc' | null) = 'desc';
    private destroy$: Subject<boolean> = new Subject<boolean>();

    @HostBinding('class')
    get cssClasses() {
        return [
            this.sortDisabled ? `eui-table__sortable-col--disabled` : ``,
        ].join(' ').trim();
    }

    constructor(private euiTableSortService: EuiTableSortService) {}

    ngOnInit() {
        if (this.defaultOrder) {
            this.order = this.sortOrder;
            this.euiTableSortService.setSort(this.sortOn, this.order);
        }

        this.euiTableSortService.sortingParams$.pipe(
            takeUntil(this.destroy$),
        ).subscribe((sortingParams: { sort: (string | null), order: string }) => {
            if (sortingParams.sort !== this.sortOn) {
                this.order = null;
            }
        });
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    public click() {
        if (!this.sortDisabled) {
            this.order = this.order === 'asc' ? 'desc' : 'asc';
            this.euiTableSortService.setSort(this.sortOn, this.order);
        }
    }
}
